var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{class:['message-toast', _vm.type],on:{"click":_vm.hide}},[_c('div',{staticClass:"message-content"},[_c('span',{staticClass:"message-icon"},[_vm._v(_vm._s(_vm.icon))]),_c('span',{staticClass:"message-text"},[_vm._v(_vm._s(_vm.text))])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }